export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazioni sul corrispondente"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Conto / E-mail / Telefono"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Indirizzo cripto / E-mail / Telefono"])}
}